<div
    class="tw-flex tw-justify-center md:tw-max-h-[54px] lg:tw-w-[80%] tw-w-[100%] sm:tw-w-full tw-mb-[42px] tw-m-auto tw-px-[28px]"
>
    <ng-container *ngFor="let tab of tabs; let first = first; let last = last">
        <button
            [attr.ga-event-id]="makeSlug(tab.label) + '_button_jc3_click'"
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="tab.label + 'Button Click'"
            ga-track="track"
            class="tw-border tw-h-auto md:tw-h-[54px] !tw-font-semibold tw-w-[232px] tw-leading-[18px] !tw-text-[16px] tw-border-[#00000099] tw-px-2 lg:tw-px-3 tw-py-2 md:tw-py-0 tw-overflow-hidden tw-break-words"
            [ngClass]="{
                'tw-bg-[#024B3F] tw-text-white': activeTab === tab.value,
                'tw-bg-transparent tw-text-[#7B7575]': activeTab !== tab.value,
                'md:tw-rounded-l-full tw-rounded-l-[14px]': first,
                'md:tw-rounded-r-full tw-rounded-r-[14px]': last,
                'tw-border-r-[0.5px]': !last,
                'tw-border-l-[0.5px]': !first
            }"
            (click)="toggleTab(tab.value)"
        >
            {{ tab.label }}
        </button>
    </ng-container>
</div>

<!-- Active tab content -->
<div class="tw-mt-4">
    <ng-container *ngFor="let tab of tabs">
        <ng-container *ngIf="activeTab === tab.value">
            <ng-container
                *ngTemplateOutlet="tab.template; context: { data: tab.data }"
            ></ng-container>
        </ng-container>
    </ng-container>
</div>
